import { render } from "./RoleFormDialog.vue?vue&type=template&id=1b7c686f&scoped=true"
import script from "./RoleFormDialog.vue?vue&type=script&lang=js"
export * from "./RoleFormDialog.vue?vue&type=script&lang=js"

import "./RoleFormDialog.vue?vue&type=style&index=0&id=1b7c686f&lang=css"
import "./RoleFormDialog.vue?vue&type=style&index=1&id=1b7c686f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7c686f"]])

export default __exports__